var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'mega-button' : true, 'disabled' : _vm.disabled}},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.buttonText))]),(!_vm.disabled)?_c('a',{staticClass:"cover",attrs:{"href":_vm.buttonUrl}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }